module.exports = __webpack_public_path__ + "img/bard.125d79b5.svg";